import React, { useState } from 'react';

import { RadioInput } from '@mm/components';
import SuppressionSettingsController from '@mm/state/controllers/SuppressionSettingsController';
import {
  CaptureActionEnum,
  SuppressionSettingsModel,
} from '@mm/state/model/SuppressionSettingsModel';

import { errorToast } from '../../../../../../../../common/helpers/toast';
import { BaseIntegration } from '../../../BaseIntegration/BaseIntegration';
import { BaseIntegrationHeader } from '../../../BaseIntegration/BaseIntegrationHeader';
import css from './ContactSuppression.module.css';

type SupressionSettingsProps = {
  sectionProps: any;
  facebookPageId: number;
  setting: SuppressionSettingsModel;
  onChange: (setting: SuppressionSettingsModel) => void;
};

const RADIO_OPTIONS = [
  {
    label: <>Do not capture Supressed Contacts</>,
    value: CaptureActionEnum.do_not_capture,
  },
  {
    label:
      'Capture supressed contacts, but do not send emails to Supressed Contacts',
    value: CaptureActionEnum.do_not_send,
  },
];

export const SupressionSettings = ({
  sectionProps,
  facebookPageId,
  setting,
  onChange,
}: SupressionSettingsProps) => {
  const [busy, setBusy] = useState(false);

  const updateSupressionSettings = async captureAction => {
    setBusy(true);
    let newSettings;
    try {
      newSettings = await SuppressionSettingsController.updateSettings(
        facebookPageId,
        {
          id: setting.id,
          captureAction,
        },
      );
    } catch (err) {
      errorToast('Error updating capturing settings', 'top-right');
      return;
    } finally {
      setBusy(false);
    }
    onChange(newSettings);
  };

  const onCaptureActionChange = e => {
    updateSupressionSettings(e.target.value);
  };

  const isChecked = (value: CaptureActionEnum) =>
    value === setting.captureAction;

  return (
    <BaseIntegration
      titleComponent={
        <BaseIntegrationHeader
          title="Capturing Suppressed Contacts Settings"
          {...sectionProps}
        />
      }
      accorditionItemProps={{
        caretStyleIcon: false,
        openOnMount: true,
        canToggle: false,
        showArrow: false,
      }}
    >
      <section>
        {RADIO_OPTIONS.map(option => (
          <RadioInput
            key={option.value}
            label={option.label}
            name="suppression-capture-action"
            checked={isChecked(option.value)}
            value={option.value}
            readOnly={busy}
            onChange={onCaptureActionChange}
          />
        ))}
      </section>
    </BaseIntegration>
  );
};
